export default "__VITE_ASSET__DyP6Smaz__"